export const fetch_customer_details_api = "eud/auth/customer/details";
